function e({
  id: t,
  name: n,
  label: r,
  type: u
}) {
  return t || (r && n ? n : r || `${u ? `${u}-` : ""}${Math.random().toString()}`);
}
export {
  e as default
};
